var map = {
	"./assets/fonts/Lato-Black.woff": "./assets/fonts/Lato-Black.woff",
	"./assets/fonts/Lato-BlackItalic.woff": "./assets/fonts/Lato-BlackItalic.woff",
	"./assets/fonts/Lato-Bold.ttf": "./assets/fonts/Lato-Bold.ttf",
	"./assets/fonts/Lato-Bold.woff": "./assets/fonts/Lato-Bold.woff",
	"./assets/fonts/Lato-BoldItalic.woff": "./assets/fonts/Lato-BoldItalic.woff",
	"./assets/fonts/Lato-Italic.ttf": "./assets/fonts/Lato-Italic.ttf",
	"./assets/fonts/Lato-Italic.woff": "./assets/fonts/Lato-Italic.woff",
	"./assets/fonts/Lato-Light.woff": "./assets/fonts/Lato-Light.woff",
	"./assets/fonts/Lato-LightItalic.woff": "./assets/fonts/Lato-LightItalic.woff",
	"./assets/fonts/Lato-Regular.ttf": "./assets/fonts/Lato-Regular.ttf",
	"./assets/fonts/Lato-Regular.woff": "./assets/fonts/Lato-Regular.woff",
	"./assets/fonts/Lato-Thin.woff": "./assets/fonts/Lato-Thin.woff",
	"./assets/fonts/Lato-ThinItalic.woff": "./assets/fonts/Lato-ThinItalic.woff",
	"./assets/fonts/ss-community.woff": "./assets/fonts/ss-community.woff",
	"./assets/fonts/ss-social-circle.woff": "./assets/fonts/ss-social-circle.woff",
	"./assets/fonts/ss-social-regular.woff": "./assets/fonts/ss-social-regular.woff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./. sync recursive \\.(eot%7Cttf%7Cwoff)$";